module.exports = __webpack_public_path__ + "c908281a23558922ef9d44ce49240372.svg";